
import { defineComponent } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { addStartDateQuery, addEndDateQuery } from '@/types/forms/date-range-picker'

export default defineComponent({
  props: {
    startDate: {
      type: [String, Date],
      'default': () => (''),
    },
    endDate: {
      type: [String, Date],
      'default': () => (''),
    },
  },
  emits: ['update:startDate', 'update:endDate'],
  setup(props, context) {
    const router = useRouter()
    const route = useRoute()

    const updateStartDate = (value: Date) => {
      context.emit('update:startDate', value)
      router.push({ path: route.path, query: addStartDateQuery(value) })
    }

    const updateEndDate = (value: Date) => {
      context.emit('update:endDate', value)
      router.push({ path: route.path, query: addEndDateQuery(value) })
    }

    return {
      updateStartDate,
      updateEndDate
    }
  },
})
